const convertPrice = (price) => {
    if (price) {
        return price.includes('$')
            ? Number(price.substring(1).replace(/,/g, ''))
            : Number(price);
    }
    return 0;
};

export default convertPrice;
